<template>
    <section class='func-buttons'>
        <div class="buttons btn_soldout" v-if="shelf && sellOut">Sold Out</div>
        <div class="buttons" v-else :class="hideCart">
            <!-- 客服 -->
            <div class="button-left">
                <template v-if="netAccount || !$isZh && !netAccount">
                  <button class="button contact" @click="customerService">
                    <img :src="onlineServiceIcon" alt=""/>
                    <span>{{ $t("message.goods.service") }}</span>
                  </button>
                </template>
            </div>
            <div class="button-right">
                <button
                    v-if="normal"
                    class="button add-cart" @click="addToCart"
                >
                    {{ $t("message.goods.addCart") }}
                </button>
                <button
                    v-if="normal"
                    @click="placeAnOrder"
                    class="button buy"
                >
                    {{ $t("message.goods.nowBuy") }}
                </button>
                <!-- 已下架 已售罄 => 我想要 -->
                <van-button
                    block
                    class="mywant"
                    v-if="isDisable"
                    @click="myWant"
                    color="#333"
                    square
                >
                    <template>
                        {{$t("message.goods.myWant")}}
                    </template>
                </van-button>
            </div>
        </div>
    </section>
</template>
<script>
import { Button } from 'vant';
export default {
    components: {
        [Button.name]: Button
    },
    props: {
        stock: Number,
        lockStock: Number,
        deleted: Number,
        showAppStatus: Number,
        shelfStatus: Number,
        goodsId: String,
        hideAddCart: Number,
        userLikeMdse: Number,
        leftTime: Number,
        uppayShowNoGoods: Number,
        netAccount: String
    },
    data() {
        return {
            merchant: 'https://fr-static.shopshops.top/20210322/merchants.df3f442478df7736.png',
            onlineServiceIcon:
                'https://fr-static.shopshops.top/20200925/icon_shop_service@3x.55864bd4c4204da3.png', //客服图标
            addShopCarIcon:
                'https://fr-static.shopshops.top/20200925/add_shopcar@3x.d505ab831f41975d.png' //加入购物车icon
        };
    },
    computed: {
        hideCart() {
            //控制是否隐藏加入购物车
            return this.normal
                ? ''
                : 'hideCartButton';
        },
        sellOut() {
            // 已售罄
            return (
                !this.stock &&
                !this.lockStock 
            );
        },
        shelf() {
            // 已下架
            return !this.shelfStatus;
        },
        normal() {
            // 正常情况
            return this.shelfStatus && this.stock && !this.deleted;
        },
        collectIcon() {
            // 收藏图标
            return this.userLikeMdse
                ? 'https://fr-static.shopshops.top/20200925/icon_shop_Collection_selected@3x.e566a79de1bfac20.png'
                : 'https://fr-static.shopshops.top/20200925/icon_shop_Collection_nor@3x.b24e986db6cfc317.png';
        },
        // 下架/售罄 下单按钮展示判断
        isDisable() {
            return Boolean(this.shelf || this.sellOut);
        },
    },
    methods: {
        customerService() {
            this.$isLogin(function () {
                this.$emit('customer-service');
           }.bind(this));
            
        },
        addToCart() {
            const { H5_Source } = this.$route.query
            let params = {
                goodsId: this.goodsId
            }
            if (H5_Source) {
                params.H5_Source = H5_Source
            }
             this.$isLogin(function () {
                this.$emit('addCart')
           }.bind(this));
            
        },
        placeAnOrder() {
             this.$isLogin(function () {
                   // 下单
                this.$emit('place-an-order')
           }.bind(this));
        
        },
        myWant(){
             this.$isLogin(function () {
                this.$emit('myWant', true)
           }.bind(this));
            
        },
        showOut() {
            if (this.sellOut) {
                return this.$t("message.goods.soldOut")
            }

            if (this.shelf) {
                return this.$t("message.goods.nowout")
            }
        }
    }
};
</script>
<style lang="less" scoped>
img {
    display: block;
}
i {
    color: #a4a4a4;
}
.mywant {
    height: 100% !important;
    font-family: "TradeGothicLT";
    font-size: 16px;
}
.func-buttons {
    .buttons {
        bottom: 0;
        left: 0;
        display: flex;
        width: 100%;
        height: 49px;
        background-color: #fff;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);

        &.btn_soldout{
            background: #B1B8BE;
            color: #fff;
            text-align: center;
            padding: 0;
            margin: 0;
            display: block;
            line-height: 49px;
            font-size: 16px;
        }
        .button-left {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0 22px;
            .button{
                padding: 0;
            }
        }
        .button-right {
            display: flex;
            flex: 1;
            font-size: 16px;
        }
        .button {
            flex: 1;
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 0;
            font-size: 16px;
            color: #fff;
            background-color: #fff;
            -webkit-tap-highlight-color: transparent;
            &.flex2 {
                flex: 2;
            }
            &.disable {
                flex: 2;
                color: #fff;
                background-color: #b0b8bf;
                line-height: 1.2;
            }
        }
        .buy {
            background: #FE672E;
            font-family: "TradeGothicLT";
        }
        // .unpaid-style {
        //     //border-right: 50px solid #fff;
        // }
        .contact {
            display: flex;
            flex-direction: column;
            align-items: center;
            font-family: "TradeGothicLT";
            font-size: 10px;
            color: #999999;
            margin: 0 22px;
            img {
                width: 22px;
                height: 21px;
                display: block;
            }
            span {
                margin-top: 3.5px;
                white-space: nowrap;
            }
        }
        .add-cart {
            background-color: #333;
            font-family: "TradeGothicLT";
            img {
                width: 22px;
                height: 22px;
                display: block;
            }
        }
        .collect {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            font-family: PingFangTC-Regular;
            font-size: 10px;
            color: #999999;
            img {
                width: 22px;
                height: 22px;
                display: block;
            }
            span {
                margin-top: 3.5px;
                white-space: nowrap;
            }
        }
    }
    .hideCartButton {
        .button-left {
            width: 34%;
        }
        .button-right {
            width: 66%;
        }
    }
}
</style>
